export default __webpack_public_path__ + "static/media/simple3.90759cd7.webp";